import React from 'react';
import { Form, Segment, Button, Modal, Label } from 'semantic-ui-react';
import { headers, BaseURLDev } from '../../../../../_utils/config';
import swal from 'sweetalert';

export default class ModalAdd extends React.Component {
   constructor(props){
      super(props);
      this.state = {
         data:{
               "alamat": "",
               "nama": "",
               "jabatan": "",
               "kode": "",
               "contact": "",
            },

         loading:false,
         error:false,

      }

      this.onChange = this.onChange.bind(this);
      this.onSubmit = this.onSubmit.bind(this);
      this.handleKeyPress = this.handleKeyPress.bind(this)
   }

   handleKeyPress(event){
      if(event.key === '/' || event.key === '%' || event.key === "'" || event.key === '"'){
         swal("Maaf, penggunaan spesial karakter (\", ', %, /) pada isian nama atau keterangan diblock", {
            icon: "warning",
         });
      }
   }
   
   onSubmit(e){
      const { kode, nama, jabatan } = this.state.data;
      this.setState({loading:true});
      e.preventDefault();
      if(kode===null || kode===""){
         this.setState({loading:false,error:true});
         swal("", "Kolom NIP harus diisi terlebih dahulu",{icon:"error"})
      }else if(nama===null || nama===""){
         this.setState({loading:false,error:true});
         swal("", "Kolom Nama harus diisi terlebih dahulu",{icon:"error"})
         
      }else if(jabatan===null || jabatan===""){
         this.setState({loading:false,error:true});
         swal("", "Kolom Jabatan harus diisi terlebih dahulu",{icon:"error"})
      }else{
         this.setState({loading:true});
         e.preventDefault();
         fetch(`${BaseURLDev}/kuasa`,{
            method: 'POST',
            headers,
            body: JSON.stringify(this.state.data)
         })
         .then(response => {
            if (!response.ok) { 
               swal("", "Simpan data Pejabat Kuasa gagal", "error");
               this.setState({loading:false,error:true});
               return Promise.reject(response.statusText);
            }
            else{
               this.setState({
                  loading:false,
                  error:false,
                  data:{
                     "alamat": "",
                     "nama": "",
                     "jabatan": "",
                     "kode": "",
                     "contact": ""
                  }
               });
               swal("Data Pejabat Kuasa berhasil disimpan", {
                  icon: "success",
               }).then(()=>{
                  window.location.href = '/b/kuasa'
               });
               // setTimeout(()=>{
               // }, 200)
               
            }
         })
      }
   }

   onChange(e){
      let text = e.target.value.replace(/['/%"]/g, '')
      this.setState({data:{...this.state.data, [e.target.name]:text}});
   }

   render() {
      const {nama,jabatan,kode,alamat,contact} = this.state.data;
      const {loading} = this.state;
      
      return (
         <div>
            <Modal
               open={this.props.open}
               onClose={this.props.onClose}
               closeOnEscape={false}
               closeOnRootNodeClick={false}
               size="small"
            >
               <Modal.Header>
                  Tambah data pejabat/pegawai
               </Modal.Header>
               
               <Modal.Content scrolling>
                  <Segment padded>
                     <Label attached='top' color="violet">Form tambah data Pejabat/Pegawai Kuasa Pengguna Anggaran</Label>
                     <Form onSubmit={this.onSubmit} loading={loading}>              
                        <Form.Input value={kode} onChange={this.onChange} onKeyPress={this.handleKeyPress} name="kode" title="NIP/Kode Pegawai" placeholder="NIP/Kode Pegawai"/>
                        <Form.Input value={nama} onChange={this.onChange} onKeyPress={this.handleKeyPress} name="nama" title="Nama pegawai" placeholder='Nama pegawai' />               
                        <Form.Input value={jabatan} onChange={this.onChange} onKeyPress={this.handleKeyPress} name="jabatan" title="Jabatan pegawai" placeholder='Jabatan pegawai' />               
                        <Form.Input value={contact} onChange={this.onChange} onKeyPress={this.handleKeyPress} name="contact" title="Nomor contact" placeholder='Nomor contact' />               
                        <Form.TextArea value={alamat} onChange={this.onChange} onKeyPress={this.handleKeyPress} title="Alamat pegawai" placeholder='Alamat pegawai' name="alamat" />
                        <Form.Button positive>Simpan</Form.Button>
                     </Form>
                  </Segment>
               </Modal.Content>
               <Modal.Actions>
                  <Button negative onClick={this.props.onClose}>Tutup</Button>                        
               </Modal.Actions>
            </Modal>                      
         </div>
      );
   }
}



// WEBPACK FOOTER //
// ./src/components/Content/views/opd/_kuasa/ModalAdd.js